// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","judgeDescriptionHeader":"_2j_gNqe5qcPQosXcB1Sbqg","judgeIcon":"_1L6NQrxp93PxEUU8NHdMEC"};